import { useEffect, useState } from 'react';
import { clienteService, pagoService, prestamoService } from '../../services/api';
import ModalAccionesPago from '../../components/ModalAccionesPago';
import '../../styles/Pagos.css';

const PagoExtraordinario = () => {
  const [clientes, setClientes] = useState([]);
  const [clienteSeleccionado, setClienteSeleccionado] = useState('');
  const [prestamos, setPrestamos] = useState([]);
  const [prestamoSeleccionado, setPrestamoSeleccionado] = useState(null);
  const [pagarCapital, setPagarCapital] = useState(true);
  const [pagarInteres, setPagarInteres] = useState(false);
  const [pagarMora, setPagarMora] = useState(false);
  const [busquedaCliente, setBusquedaCliente] = useState('');
  const [mostrarDropdown, setMostrarDropdown] = useState(false);
  const [clienteObj, setClienteObj] = useState(null);
  const [formData, setFormData] = useState({
    monto_total: '',
    tipo_extraordinario: 'abono_capital',
    fecha_pago: new Date().toISOString().split('T')[0],
    detalle: ''
  });
  const [mensaje, setMensaje] = useState({ tipo: '', texto: '' });
  // Estados para el modal de acciones después del pago
  const [mostrarModalAcciones, setMostrarModalAcciones] = useState(false);
  const [datosPagoGuardado, setDatosPagoGuardado] = useState(null);

  useEffect(() => {
    cargarClientes();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.form-group')) {
        setMostrarDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const cargarClientes = async () => {
    try {
      const response = await clienteService.getAll({ per_page: 1000 });
      setClientes(response.data.clientes || []);
    } catch (error) {
      console.error('Error al cargar clientes:', error);
    }
  };

  const clientesFiltrados = clientes.filter(cliente => {
    const termino = busquedaCliente.toLowerCase().trim();
    if (!termino) return true;

    return (
      (cliente.nombres && cliente.nombres.toLowerCase().includes(termino)) ||
      (cliente.apellidos && cliente.apellidos.toLowerCase().includes(termino)) ||
      (cliente.cedula && cliente.cedula.includes(termino)) ||
      (cliente.apodo && cliente.apodo.toLowerCase().includes(termino)) ||
      cliente.id.toString().includes(termino) ||
      (cliente.nombres && cliente.apellidos &&
       `${cliente.nombres} ${cliente.apellidos}`.toLowerCase().includes(termino))
    );
  }).slice(0, 10);

  const seleccionarCliente = async (cliente) => {
    setClienteObj(cliente);
    setBusquedaCliente(`${cliente.nombres} ${cliente.apellidos} - ${cliente.cedula}`);
    setMostrarDropdown(false);
    setClienteSeleccionado(cliente.id);
    setPrestamos([]);
    setPrestamoSeleccionado(null);

    try {
      const response = await prestamoService.getAll({ cliente_id: cliente.id });
      const prestamosActivos = (response.data.prestamos || []).filter(
        p => p.estado === 'activo'
      );
      setPrestamos(prestamosActivos);
    } catch (error) {
      console.error('Error al cargar préstamos:', error);
    }
  };

  const limpiarCliente = () => {
    setClienteObj(null);
    setClienteSeleccionado('');
    setBusquedaCliente('');
    setPrestamos([]);
    setPrestamoSeleccionado(null);
  };

  const handleSeleccionarPrestamo = (prestamo) => {
    setPrestamoSeleccionado(prestamo);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const calcularDistribucion = () => {
    const monto = parseFloat(formData.monto_total) || 0;

    // Si se usan checkboxes, distribuir según selección
    if (pagarCapital || pagarInteres || pagarMora) {
      const opciones = [pagarCapital, pagarInteres, pagarMora].filter(Boolean).length;
      const montoPorOpcion = monto / opciones;

      return {
        capital: pagarCapital ? montoPorOpcion : 0,
        interes: pagarInteres ? montoPorOpcion : 0,
        mora: pagarMora ? montoPorOpcion : 0
      };
    }

    // Fallback al tipo tradicional
    const tipo = formData.tipo_extraordinario;

    switch (tipo) {
      case 'abono_capital':
        return {
          capital: monto,
          interes: 0,
          mora: 0
        };
      case 'pago_interes':
        return {
          capital: 0,
          interes: monto,
          mora: 0
        };
      case 'pago_mora':
        return {
          capital: 0,
          interes: 0,
          mora: monto
        };
      case 'pago_multiple':
        // Distribuir proporcionalmente
        const pendienteCapital = prestamoSeleccionado.capital -
          (prestamoSeleccionado.capital / prestamoSeleccionado.cuotas * prestamoSeleccionado.cuotas_pagadas);
        const pendienteInteres = prestamoSeleccionado.interes -
          (prestamoSeleccionado.interes / prestamoSeleccionado.cuotas * prestamoSeleccionado.cuotas_pagadas);

        const total = pendienteCapital + pendienteInteres;
        const ratioCapital = pendienteCapital / total;
        const ratioInteres = pendienteInteres / total;

        return {
          capital: monto * ratioCapital,
          interes: monto * ratioInteres,
          mora: 0
        };
      default:
        return { capital: 0, interes: 0, mora: 0 };
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!prestamoSeleccionado) {
      setMensaje({ tipo: 'error', texto: 'Debe seleccionar un préstamo' });
      return;
    }

    if (!pagarCapital && !pagarInteres && !pagarMora) {
      setMensaje({ tipo: 'error', texto: 'Debe seleccionar al menos una opción de pago' });
      return;
    }

    const distribucion = calcularDistribucion();

    // CONFIRMACIÓN ANTES DE GUARDAR
    const nombreCliente = prestamoSeleccionado.cliente ? 
      `${prestamoSeleccionado.cliente.nombres} ${prestamoSeleccionado.cliente.apellidos}` : 
      'Cliente';
    
    const tipoExtraordinarioLabel = formData.tipo_extraordinario === 'abono_capital' ? 'Abono a Capital' :
                                    formData.tipo_extraordinario === 'adelanto_cuota' ? 'Adelanto de Cuota' :
                                    'Liquidación Total';
    
    const confirmacion = window.confirm(
      `¿REGISTRAR PAGO EXTRAORDINARIO?\n\n` +
      `Cliente: ${nombreCliente.toUpperCase()}\n` +
      `Préstamo ID: ${prestamoSeleccionado.id}\n` +
      `Tipo: ${tipoExtraordinarioLabel}\n` +
      `Total a pagar: $${parseFloat(formData.monto_total).toFixed(2)}\n` +
      `Distribución:\n` +
      `  - Capital: $${distribucion.capital.toFixed(2)}\n` +
      `  - Interés: $${distribucion.interes.toFixed(2)}\n` +
      `  - Mora: $${distribucion.mora.toFixed(2)}\n\n` +
      `¿Desea continuar?`
    );

    if (!confirmacion) {
      return;
    }

    try {
      const data = {
        prestamo_id: prestamoSeleccionado.id,
        monto_capital: distribucion.capital,
        monto_interes: distribucion.interes,
        monto_mora: distribucion.mora,
        monto_total: parseFloat(formData.monto_total),
        tipo_pago: 'extraordinario',
        fecha_pago: formData.fecha_pago,
        detalle: `${formData.tipo_extraordinario} - ${formData.detalle}`
      };

      const response = await pagoService.create(data);
      setMensaje({ tipo: 'success', texto: '✅ PAGO EXTRAORDINARIO REGISTRADO EXITOSAMENTE' });

      // Guardar datos para el modal de acciones
      setDatosPagoGuardado({
        nombreCliente,
        prestamoId: prestamoSeleccionado.id,
        montoPagado: parseFloat(formData.monto_total),
        cuotasPagadas: prestamoSeleccionado.cuotas_pagadas,
        totalCuotas: prestamoSeleccionado.cuotas,
        pagoId: response.data.id,
        cliente: prestamoSeleccionado.cliente,
        prestamo: prestamoSeleccionado
      });

      // Mostrar modal de acciones
      setMostrarModalAcciones(true);

    } catch (error) {
      setMensaje({ tipo: 'error', texto: error.response?.data?.error || 'Error al registrar el pago' });
    }
  };

  const distribucion = prestamoSeleccionado && formData.monto_total ? calcularDistribucion() : null;

  const limpiarFormularioDespuesDePago = () => {
    setPrestamoSeleccionado(null);
    setPagarCapital(true);
    setPagarInteres(false);
    setPagarMora(false);
    setFormData({
      monto_total: '',
      tipo_extraordinario: 'abono_capital',
      fecha_pago: new Date().toISOString().split('T')[0],
      detalle: ''
    });
    setClienteSeleccionado('');
    setPrestamos([]);
    setBusquedaCliente('');
    setClienteObj(null);
  };

  const handleCerrarModalAcciones = () => {
    setMostrarModalAcciones(false);
    limpiarFormularioDespuesDePago();
  };

  const handleImprimirRecibo = () => {
    if (datosPagoGuardado) {
      window.open(`/recibo/${datosPagoGuardado.pagoId}`, '_blank');
    }
  };

  const handleEnviarWhatsApp = () => {
    if (datosPagoGuardado && datosPagoGuardado.cliente) {
      const celular = datosPagoGuardado.cliente.celular;
      if (!celular) {
        alert('❌ El cliente no tiene número de celular registrado');
        return;
      }

      const mensaje = 
        `✅ *Pago Extraordinario Registrado*\n\n` +
        `Cliente: ${datosPagoGuardado.nombreCliente}\n` +
        `Préstamo ID: ${datosPagoGuardado.prestamoId}\n` +
        `Monto pagado: $${datosPagoGuardado.montoPagado.toFixed(2)}\n\n` +
        `¡Gracias por su pago!`;

      // Normalizar número y asegurar código de país (+1)
      const soloDigitos = celular.replace(/\D/g, '');
      const numeroWhatsApp = soloDigitos.startsWith('1') ? soloDigitos : `1${soloDigitos}`;

      // Detectar móvil vs desktop
      const esMovil = /Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent);
      if (esMovil) {
        const appUrl = `whatsapp://send?phone=${numeroWhatsApp}&text=${encodeURIComponent(mensaje)}`;
        window.location.href = appUrl;
        setTimeout(() => {
          const webUrl = `https://wa.me/${numeroWhatsApp}?text=${encodeURIComponent(mensaje)}`;
          window.open(webUrl, '_blank');
        }, 600);
      } else {
        const webUrl = `https://web.whatsapp.com/send?phone=${numeroWhatsApp}&text=${encodeURIComponent(mensaje)}`;
        window.open(webUrl, '_blank');
      }
    }
  };

  return (
    <div className="pago-extraordinario-container">
      <h2>Pago Extraordinario</h2>

      {mensaje.texto && (
        <div className={`mensaje ${mensaje.tipo}`}>
          {mensaje.texto}
        </div>
      )}

      <div className="busqueda-section">
        <div className="form-group">
          <label>Seleccionar Cliente:</label>
          <div style={{ position: 'relative' }}>
            <input
              type="text"
              className="form-control"
              placeholder="Buscar por nombre, cédula, apodo o ID..."
              value={busquedaCliente}
              onChange={(e) => {
                setBusquedaCliente(e.target.value);
                setMostrarDropdown(true);
              }}
              onFocus={() => setMostrarDropdown(true)}
            />
            {clienteObj && (
              <button
                type="button"
                onClick={limpiarCliente}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'transparent',
                  border: 'none',
                  fontSize: '20px',
                  cursor: 'pointer',
                  color: '#6c757d'
                }}
              >
                ×
              </button>
            )}

            {mostrarDropdown && busquedaCliente && clientesFiltrados.length > 0 && (
              <div style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                backgroundColor: 'white',
                border: '1px solid #ddd',
                borderRadius: '4px',
                maxHeight: '400px',
                overflowY: 'auto',
                zIndex: 1000,
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
              }}>
                {clientesFiltrados.map((cliente) => (
                  <div
                    key={cliente.id}
                    onClick={() => seleccionarCliente(cliente)}
                    style={{
                      padding: '10px',
                      cursor: 'pointer',
                      borderBottom: '1px solid #f0f0f0',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                  >
                    {cliente.foto_url ? (
                      <img
                        src={cliente.foto_url}
                        alt={cliente.nombres}
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          objectFit: 'cover'
                        }}
                      />
                    ) : (
                      <div style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        backgroundColor: '#007bff',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 'bold'
                      }}>
                        {cliente.nombres?.charAt(0)}{cliente.apellidos?.charAt(0)}
                      </div>
                    )}
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 'bold' }}>
                        {cliente.nombres} {cliente.apellidos}
                        {cliente.apodo && (
                          <span style={{
                            marginLeft: '8px',
                            color: '#007bff',
                            fontStyle: 'italic',
                            fontWeight: 'normal'
                          }}>
                            ({cliente.apodo})
                          </span>
                        )}
                      </div>
                      <div style={{ fontSize: '0.9em', color: '#666' }}>
                        Cédula: {cliente.cedula} • ID: {cliente.id}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {prestamos.length > 0 && (
        <div className="prestamos-list">
          <h3>Préstamos Activos</h3>
          {prestamos.map(prestamo => (
            <div
              key={prestamo.id}
              className={`prestamo-item ${prestamoSeleccionado?.id === prestamo.id ? 'selected' : ''}`}
              onClick={() => handleSeleccionarPrestamo(prestamo)}
            >
              <div><strong>ID:</strong> {prestamo.id}</div>
              <div><strong>Total:</strong> ${prestamo.total.toFixed(2)}</div>
              <div><strong>Cuotas:</strong> {prestamo.cuotas_pagadas}/{prestamo.cuotas}</div>
              <div><strong>Capital Pendiente:</strong> ${(prestamo.capital - (prestamo.capital / prestamo.cuotas * prestamo.cuotas_pagadas)).toFixed(2)}</div>
            </div>
          ))}
        </div>
      )}

      {prestamoSeleccionado && (
        <form onSubmit={handleSubmit} className="pago-form">
          <div className="prestamo-info">
            <h3>Información del Préstamo</h3>
            <div className="info-grid">
              <div><strong>ID:</strong> {prestamoSeleccionado.id}</div>
              <div><strong>Capital Total:</strong> ${prestamoSeleccionado.capital.toFixed(2)}</div>
              <div><strong>Interés Total:</strong> ${prestamoSeleccionado.interes.toFixed(2)}</div>
              <div><strong>Total:</strong> ${prestamoSeleccionado.total.toFixed(2)}</div>
              <div><strong>Cuotas Pagadas:</strong> {prestamoSeleccionado.cuotas_pagadas}/{prestamoSeleccionado.cuotas}</div>
            </div>
          </div>

          {/* Opciones de pago */}
          <div style={{
            marginBottom: '1.5rem',
            padding: '1rem',
            backgroundColor: '#f5f5f5',
            borderRadius: '8px'
          }}>
            <h4 style={{marginTop: 0, marginBottom: '1rem'}}>¿Qué desea pagar?</h4>
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem'}}>
              <label style={{
                display: 'flex',
                alignItems: 'center',
                padding: '0.75rem',
                backgroundColor: pagarCapital ? '#e3f2fd' : 'white',
                borderRadius: '8px',
                cursor: 'pointer',
                border: pagarCapital ? '2px solid #2196F3' : '2px solid #ddd',
                transition: 'all 0.2s'
              }}>
                <input
                  type="checkbox"
                  checked={pagarCapital}
                  onChange={(e) => setPagarCapital(e.target.checked)}
                  style={{
                    width: '20px',
                    height: '20px',
                    marginRight: '0.75rem',
                    cursor: 'pointer'
                  }}
                />
                <div>
                  <div style={{fontWeight: 'bold', color: '#333'}}>Capital</div>
                </div>
              </label>

              <label style={{
                display: 'flex',
                alignItems: 'center',
                padding: '0.75rem',
                backgroundColor: pagarInteres ? '#e8f5e9' : 'white',
                borderRadius: '8px',
                cursor: 'pointer',
                border: pagarInteres ? '2px solid #4CAF50' : '2px solid #ddd',
                transition: 'all 0.2s'
              }}>
                <input
                  type="checkbox"
                  checked={pagarInteres}
                  onChange={(e) => setPagarInteres(e.target.checked)}
                  style={{
                    width: '20px',
                    height: '20px',
                    marginRight: '0.75rem',
                    cursor: 'pointer'
                  }}
                />
                <div>
                  <div style={{fontWeight: 'bold', color: '#333'}}>Interés</div>
                </div>
              </label>

              <label style={{
                display: 'flex',
                alignItems: 'center',
                padding: '0.75rem',
                backgroundColor: pagarMora ? '#fff3e0' : 'white',
                borderRadius: '8px',
                cursor: 'pointer',
                border: pagarMora ? '2px solid #ff9800' : '2px solid #ddd',
                transition: 'all 0.2s'
              }}>
                <input
                  type="checkbox"
                  checked={pagarMora}
                  onChange={(e) => setPagarMora(e.target.checked)}
                  style={{
                    width: '20px',
                    height: '20px',
                    marginRight: '0.75rem',
                    cursor: 'pointer'
                  }}
                />
                <div>
                  <div style={{fontWeight: 'bold', color: '#333'}}>Mora</div>
                </div>
              </label>
            </div>
          </div>

          <div className="form-grid">
            <div className="form-group">
              <label>Tipo de Pago Extraordinario:</label>
              <select
                name="tipo_extraordinario"
                value={formData.tipo_extraordinario}
                onChange={handleChange}
                required
              >
                <option value="abono_capital">Abono a Capital</option>
                <option value="pago_interes">Pago de Interés</option>
                <option value="pago_mora">Pago de Mora</option>
                <option value="pago_multiple">Pago Múltiple (Distribuido)</option>
              </select>
            </div>

            <div className="form-group">
              <label>Monto Total:</label>
              <input
                type="number"
                name="monto_total"
                value={formData.monto_total}
                onChange={handleChange}
                step="0.01"
                required
              />
            </div>

            <div className="form-group">
              <label>Fecha de Pago:</label>
              <input
                type="date"
                name="fecha_pago"
                value={formData.fecha_pago}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group full-width">
              <label>Detalle:</label>
              <textarea
                name="detalle"
                value={formData.detalle}
                onChange={handleChange}
                rows="3"
              />
            </div>
          </div>

          {distribucion && (
            <div className="distribucion-pago">
              <h3>Distribución del Pago</h3>
              <div className="distribucion-grid">
                <div className="distribucion-item">
                  <label>A Capital:</label>
                  <span>${distribucion.capital.toFixed(2)}</span>
                </div>
                <div className="distribucion-item">
                  <label>A Interés:</label>
                  <span>${distribucion.interes.toFixed(2)}</span>
                </div>
                <div className="distribucion-item">
                  <label>A Mora:</label>
                  <span>${distribucion.mora.toFixed(2)}</span>
                </div>
                <div className="distribucion-item total">
                  <label>Total:</label>
                  <span>${formData.monto_total}</span>
                </div>
              </div>
            </div>
          )}

          <div className="form-actions">
            <button type="submit" className="btn-primary">Registrar Pago Extraordinario</button>
            <button
              type="button"
              className="btn-secondary"
              onClick={() => {
                setPrestamoSeleccionado(null);
                setFormData({
                  monto_total: '',
                  tipo_extraordinario: 'abono_capital',
                  fecha_pago: new Date().toISOString().split('T')[0],
                  detalle: ''
                });
              }}
            >
              Cancelar
            </button>
          </div>
        </form>
      )}

      {/* Modal de acciones después del pago */}
      <ModalAccionesPago
        mostrar={mostrarModalAcciones}
        onCerrar={handleCerrarModalAcciones}
        pagoInfo={datosPagoGuardado}
        onImprimirRecibo={handleImprimirRecibo}
        onEnviarWhatsApp={handleEnviarWhatsApp}
      />
    </div>
  );
};

export default PagoExtraordinario;
